module.exports = __webpack_public_path__ + "static/media/Lyksvad.1a6a61c9.svg";